import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";

import { HttpResponsesHandlersFactory } from "@bbwt/modules/data-service";
import { PagedCrudService } from "@features/grid";
import { IRavenStatus } from "./models/raven-status";


@Injectable({
    providedIn: "root"
})
export class RavenStatusService extends PagedCrudService<IRavenStatus> {
    public readonly url = "api/raven-status";
    public readonly entityTitle = "RavenStatus";


    constructor(http: HttpClient, handlersFactory: HttpResponsesHandlersFactory) {
        super(http, handlersFactory);
    }
}